"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewGatewayLogDownloadRequest extends new_item_1.default {
    constructor(newGatewayLogDownloadRequest) {
        super();
        this.gatewayId = newGatewayLogDownloadRequest.gatewayId;
    }
}
exports.default = NewGatewayLogDownloadRequest;
//# sourceMappingURL=new-gatewayLogDownloadRequest.js.map